// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arcade-webapp {
  /* Row layout */
  /* Left */
  /* Right */
}
.arcade-webapp .header-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.arcade-webapp .header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 21px;
  margin-top: 40px;
  max-width: 1018px;
}
.arcade-webapp .left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.arcade-webapp .left span {
  padding-top: 11px;
}
.arcade-webapp .right {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 735px) {
  .arcade-webapp .header-row {
    display: block;
    margin-bottom: 15px;
  }
  .arcade-webapp .header-row .left h2 {
    font-size: 28px;
  }
  .arcade-webapp .header-row .left span {
    padding-top: 7px;
  }
  .arcade-webapp .header-row .right {
    margin-top: 0px;
  }
  .arcade-webapp .header-row .right button {
    margin-left: auto;
  }
  .arcade-webapp .header-row .auto-play-section-wrapper {
    width: 100%;
    height: 57px;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
